import ParametersPageView from "./ParametersPageView";

function ParametersPage() {
  return <ParametersPageView />;
}

export default ParametersPage;
